/* Collection filter bar — Simply Carbon Fiber (2026-09-16), "Quince" layout.
   Pills open a dropdown (a bottom sheet on phones); the master "Filter" button gathers every group's panel into
   one drawer. Desktop pills filter on each tick; the master panel and the phone sheets hold changes until "View",
   which is how Quince behaves. Impulse does the actual AJAX: its listener sits on .filter-form and reads FormData,
   so every checkbox stays inside the form at all times. */
(function () {
  'use strict';
  var openKey = null, masterOpen = false, deferred = false, dirty = false, applying = false, snapshot = null;
  function q(s, r) { return (r || document).querySelector(s); }
  function all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function isMobile() { return window.matchMedia('(max-width: 768px)').matches; }
  function form() { return q('[data-scf-fp-form]'); }
  function inputs() { var f = form(); return f ? all('.scf-fp__in', f) : []; }
  function panelOf(item) { return item.__scfPanel || q('[data-scf-fp-panel]', item); }
  function ovlOf(item) { return item.__scfOvl || q('.scf-fp__ovl', item); }
  function lock(on) { document.documentElement.classList.toggle('scf-fp-lock', !!on); }
  function take() { snapshot = inputs().map(function (i) { return i.checked; }); }
  function revert() { if (!snapshot) return; inputs().forEach(function (i, n) { if (n < snapshot.length) i.checked = snapshot[n]; }); snapshot = null; }

  /* iOS Safari paints a fixed panel badly inside the horizontally scrolling bar, so on phones the sheet is
     lifted out of it — to the form, never to <body>, or the checkboxes would leave the form and stop filtering. */
  function lift(item) {
    var p = panelOf(item), o = ovlOf(item), f = form();
    if (!p || !f || p.__scfHome) return;
    p.__scfHome = item; o.__scfHome = item; item.__scfPanel = p; item.__scfOvl = o;
    p.classList.add('is-out'); o.classList.add('is-out');
    f.appendChild(o); f.appendChild(p);
  }
  function drop(item) {
    var p = item.__scfPanel, o = item.__scfOvl;
    if (!p) return;
    p.classList.remove('is-out'); o.classList.remove('is-out');
    item.appendChild(o); item.appendChild(p);
    p.__scfHome = null; o.__scfHome = null; item.__scfPanel = null; item.__scfOvl = null;
  }

  function closeGroups() {
    all('[data-scf-fp-item]').forEach(function (it) {
      var p = panelOf(it), o = ovlOf(it), b = q('[data-scf-fp-toggle]', it);
      if (p && !p.classList.contains('is-in-master')) p.hidden = true;
      if (o) o.hidden = true;
      if (b) b.setAttribute('aria-expanded', 'false');
      drop(it);
    });
    openKey = null;
  }
  function openGroup(item) {
    closeGroups();
    if (isMobile()) lift(item);
    var p = panelOf(item), o = ovlOf(item), b = q('[data-scf-fp-toggle]', item);
    if (!p) return;
    p.style.left = ''; p.style.right = '';
    p.hidden = false; if (o) o.hidden = false; if (b) b.setAttribute('aria-expanded', 'true');
    openKey = item.dataset.scfFpItem;
    deferred = isMobile(); dirty = false;
    if (deferred) { take(); lock(true); seedCount(); }
    else {
      var r = p.getBoundingClientRect();
      if (r.right > window.innerWidth - 12) { p.style.left = 'auto'; p.style.right = '0'; }
    }
  }

  function openMaster() {
    closeGroups();
    var m = q('[data-scf-fp-master]'), body = q('[data-scf-fp-mbody]'), ovl = q('.scf-fp__movl');
    if (!m || !body) return;
    body.innerHTML = '';
    var groups = all('[data-scf-fp-item]').filter(function (it) { return !it.hasAttribute('data-scf-fp-device'); });
    /* few groups: open them all, on phones too, so no option hides behind a tap; many: first open, rest folded */
    var expand = !isMobile() || groups.length <= 4;
    groups.forEach(function (it, idx) {
      var p = panelOf(it);
      if (!p) return;
      var sec = document.createElement('div'); sec.className = 'scf-fp__sec';
      var head = document.createElement('button');
      head.type = 'button'; head.className = 'scf-fp__sect'; head.setAttribute('data-scf-fp-sect', '');
      var open = expand || idx === 0 || q('.scf-fp__in:checked', p);
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
      head.innerHTML = '<span>' + (it.dataset.scfFpLabel || '') + '</span>'
        + '<svg class="scf-fp__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
      p.classList.add('is-in-master'); p.hidden = !open;
      it.__scfMaster = true;
      sec.appendChild(head); sec.appendChild(p); body.appendChild(sec);
    });
    m.hidden = false; if (ovl) ovl.hidden = false;
    var btn = q('[data-scf-fp-open-master]'); if (btn) btn.setAttribute('aria-expanded', 'true');
    masterOpen = true; deferred = true; dirty = false; take(); lock(true);
    seedCount();
  }
  function closeMaster(keep) {
    var m = q('[data-scf-fp-master]'), ovl = q('.scf-fp__movl');
    all('[data-scf-fp-item]').forEach(function (it) {
      if (!it.__scfMaster) return;
      var p = q('[data-scf-fp-panel].is-in-master[id="scf-fp-' + it.dataset.scfFpItem + '"]') || null;
      if (p) { p.classList.remove('is-in-master'); p.hidden = true; it.appendChild(p); }
      it.__scfMaster = false;
    });
    if (m) m.hidden = true; if (ovl) ovl.hidden = true;
    var btn = q('[data-scf-fp-open-master]'); if (btn) btn.setAttribute('aria-expanded', 'false');
    masterOpen = false; deferred = false;
    if (!keep) lock(false);
  }
  function closeAll(cancel) {
    closeSort();
    if (cancel && deferred && dirty) revert();
    snapshot = null; dirty = false;
    if (masterOpen) closeMaster();
    closeGroups();
    deferred = false; lock(false);
  }

  /* the View button carries the live result count: on every held change the collection is fetched with the
     form's current params and the count read off the fresh bar. The only number in the whole filter UI. */
  var countTimer = null, countAbort = null;
  function setCount(n) {
    all('[data-scf-fp-apply]').forEach(function (b) {
      b.textContent = (n === null || n === undefined) ? 'View' : 'View (' + n + ')';
      b.classList.toggle('is-zero', n === 0);
    });
  }
  function seedCount() { var bar = q('[data-scf-fp]'); if (bar && bar.dataset.scfFpCount !== undefined) setCount(parseInt(bar.dataset.scfFpCount, 10)); }
  function liveCount() {
    clearTimeout(countTimer);
    countTimer = setTimeout(function () {
      var f = form(); if (!f) return;
      var params = new URLSearchParams();
      new FormData(f).forEach(function (v, k) { if (v !== '') params.append(k, v); });
      if (countAbort) countAbort.abort();
      countAbort = new AbortController();
      setCount(null);
      fetch(location.pathname + '?' + params.toString(), { signal: countAbort.signal, credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var bar = doc.querySelector('[data-scf-fp]');
          if (bar && bar.dataset.scfFpCount !== undefined) setCount(parseInt(bar.dataset.scfFpCount, 10)); else seedCount();
        })
        .catch(function () { seedCount(); });
    }, 250);
  }

  /* send one real input event through to Impulse, which reads FormData off the form */
  function fire() {
    var el = inputs()[0];
    if (!el) return;
    applying = true;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    applying = false;
  }

  /* while a change is being held, keep it from reaching Impulse */
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || !el.classList || !el.classList.contains('scf-fp__in')) return;
    if (applying || !deferred) return;
    e.stopPropagation();
    dirty = true;
    liveCount();
    var panel = el.closest('[data-scf-fp-panel]');
    var clear = panel && q('[data-scf-fp-clear]', panel);
    if (clear) clear.hidden = !q('.scf-fp__in:checked', panel);
  }, true);

  /* phone sort sheet: the real <select> stays in the bar for desktop and for Impulse, which listens on it */
  function openSort() {
    closeAll(true);
    var p = q('[data-scf-fp-sort-panel]'), o = q('.scf-fp__ovl--sort'), b = q('[data-scf-fp-sort-open]');
    if (!p) return;
    p.hidden = false; if (o) o.hidden = false; if (b) b.setAttribute('aria-expanded', 'true');
    lock(true);
  }
  function closeSort() {
    var p = q('[data-scf-fp-sort-panel]'), o = q('.scf-fp__ovl--sort'), b = q('[data-scf-fp-sort-open]');
    if (p) p.hidden = true; if (o) o.hidden = true; if (b) b.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-scf-fp-toggle], [data-scf-fp-close], [data-scf-fp-clear], [data-scf-fp-clearall], [data-scf-fp-open-master], [data-scf-fp-apply], [data-scf-fp-more], [data-scf-fp-sect], [data-scf-fp-sort-open], [data-scf-fp-sort-pick]');
    if (!t) {
      /* 2026-09-18: a click anywhere outside the open drawer closes it, the same as its X (held changes are dropped);
         the backdrop catches most of these, this covers anything above it (header, chat launcher) */
      if (masterOpen && !e.target.closest('[data-scf-fp-master]')) { closeAll(true); return; }
      if (!isMobile() && !masterOpen && !e.target.closest('[data-scf-fp-item], [data-scf-fp-panel]')) closeAll(false);
      return;
    }
    var host = t.closest('[data-scf-fp-panel], .scf-fp__ovl');
    var item = t.closest('[data-scf-fp-item]') || (host && host.__scfHome)
      || (host && host.id ? q('[data-scf-fp-item="' + host.id.replace('scf-fp-', '') + '"]') : null);

    if (t.hasAttribute('data-scf-fp-sort-open')) {
      var sp = q('[data-scf-fp-sort-panel]');
      (sp && !sp.hidden) ? (closeSort(), lock(false)) : openSort();
      return;
    }
    if (t.hasAttribute('data-scf-fp-sort-pick')) {
      var sel = q('#SortBy');
      closeSort(); lock(false);
      if (sel && sel.value !== t.dataset.scfFpSortPick) {
        sel.value = t.dataset.scfFpSortPick;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
    if (t.hasAttribute('data-scf-fp-open-master')) { masterOpen ? closeAll(true) : openMaster(); return; }
    if (t.hasAttribute('data-scf-fp-toggle')) { var p = panelOf(item); (p && !p.hidden) ? closeAll(true) : openGroup(item); return; }
    if (t.hasAttribute('data-scf-fp-close')) { closeAll(true); return; }
    if (t.hasAttribute('data-scf-fp-sect')) {
      var sec = t.parentElement, pan = q('[data-scf-fp-panel]', sec);
      var open = t.getAttribute('aria-expanded') === 'true';
      t.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (pan) pan.hidden = open;
      return;
    }
    if (t.hasAttribute('data-scf-fp-more')) {
      var ul = q('[data-scf-fp-ul]', t.parentElement);
      if (!ul) return;
      var wasOpen = ul.classList.toggle('is-open');
      var label = t.textContent;
      t.textContent = t.dataset.less; t.dataset.less = label;
      if (!wasOpen) { /* label swapped back above */ }
      return;
    }
    if (t.hasAttribute('data-scf-fp-apply')) {
      if (t.classList.contains('is-zero')) return;
      if (dirty) { applyAndClose(); } else closeAll(false);
      return;
    }
    if (t.hasAttribute('data-scf-fp-clear')) {
      var pan2 = t.closest('[data-scf-fp-panel]');
      var ins = all('.scf-fp__in:checked', pan2);
      if (!ins.length) return;
      ins.forEach(function (i) { i.checked = false; });
      t.hidden = true;
      if (deferred) { dirty = true; liveCount(); } else fire();
      return;
    }
    if (t.hasAttribute('data-scf-fp-clearall')) {
      var checked = inputs().filter(function (i) { return i.checked; });
      if (!checked.length) return;
      checked.forEach(function (i) { i.checked = false; });
      all('[data-scf-fp-clear]').forEach(function (c) { c.hidden = true; });
      if (deferred) { dirty = true; liveCount(); } else { closeAll(false); fire(); }
      return;
    }
  });
  function applyAndClose() {
    snapshot = null; dirty = false;
    var wasMaster = masterOpen;
    if (wasMaster) closeMaster(true);
    closeGroups();
    deferred = false; lock(false);
    fire();
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(true); });

  /* Impulse replaces the whole section; put the shopper back where they were and keep the device links in step */
  document.addEventListener('collection:reloaded', function () {
    masterOpen = false; deferred = false; dirty = false; snapshot = null; lock(false);
    if (openKey) { var it = q('[data-scf-fp-item="' + openKey + '"]'); if (it) openGroup(it); }
    syncChips();
  });

  function syncChips() {
    var bar = q('[data-scf-fp]'); if (!bar) return;
    var keys = (bar.dataset.scfFpHidekeys || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var isDevice = function (name) { var n = name.toLowerCase(); return keys.some(function (k) { return n.indexOf(k) > -1; }); };
    var cur = new URLSearchParams(location.search);
    var carry = []; cur.forEach(function (v, k) { if ((k.indexOf('filter.') === 0 && !isDevice(k)) || k === 'sort_by') carry.push([k, v]); });
    all('.scf-dev__m[href], .scf-dev__clear[href]').forEach(function (a) {
      var u; try { u = new URL(a.getAttribute('href'), location.origin); } catch (err) { return; }
      var keep = new URLSearchParams();
      u.searchParams.forEach(function (v, k) { if (isDevice(k) || k === 'preview_theme_id') keep.append(k, v); });
      carry.forEach(function (kv) { keep.append(kv[0], kv[1]); });
      u.search = keep.toString(); a.setAttribute('href', u.pathname + u.search);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncChips); else syncChips();
})();
